'use client';

import { FC, ReactNode } from 'react';

import styles from './AddProfileButton.module.scss';

export type AddProfileButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  label: ReactNode;
  ariaLabel: string;
};

export const AddProfileButton: FC<AddProfileButtonProps> = ({ onClick, disabled = false, label, ariaLabel }) => {
  return (
    <button className={styles.button} onClick={onClick} type="button" aria-label={ariaLabel} disabled={disabled}>
      <div className={styles['icon-outer']}>
        <div className={styles['icon-inner']}>
          <span className={styles['plus-icon']} />
        </div>
      </div>
      <p className={styles.text}>{label}</p>
    </button>
  );
};
